
namespace GeniuzPOS.Purchase {
    import fld = ListAppPurRequestRow.Fields


    @Serenity.Decorators.registerClass()
    export class ListAppPurRequestGrid extends Serenity.EntityGrid<ListAppPurRequestRow, any> {
        protected getColumnsKey() { return ListAppPurRequestColumns.columnsKey; }
        protected getDialogType() { return ListAppPurRequestDialog; }
        protected getIdProperty() { return ListAppPurRequestRow.idProperty; }
        protected getInsertPermission() { return ListAppPurRequestRow.insertPermission; }
        protected getLocalTextPrefix() { return ListAppPurRequestRow.localTextPrefix; }
        protected getService() { return ListAppPurRequestService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();


             

            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.Username == Authorization.userDefinition.Username);
            var userapprole = Q.tryFirst(Administration.UserApprovalRoleRow.getLookup().items, x => x.UserId == userId.UserId);
            console.log("Id "+ userId.UserId +" userapp " + userapprole.ApprGroupCode)

            Q.first(filters, x => x.field == fld.WaitApprove).init = w => {

                (w as Serenity.StringEditor).value = userapprole.ApprGroupCode ?? "";
               
            };
         

            return filters;
        }

    }
}